import { OktaAuth } from '../myaccount';

// Export only a single object
export default OktaAuth;
